import React, { FC } from 'react';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { CdnIcon } from '@shared/ui';
import { CloseButton } from '../../../../../BaseComponents';
import { ExchangeRefundBreadcrumb } from '../../model';

interface Props {
	className?: string;
	breadcrumbs: ExchangeRefundBreadcrumb[];
}

const ExchangeRefundMobileBreadcrumbs: FC<Props> = ({ className, breadcrumbs }) => {
	const { ExchangeRefundMobileBreadcrumbs: css } = useTheme('Entities').Order;

	return (
		<div className={cn(css.root, className)}>
			{!!breadcrumbs?.length &&
				breadcrumbs.map(({ label, description, icon, disabled, onAction }, index) => (
					<div key={`${index}-${label}`} className={css.breadcrumb}>
						<div className={css.leftBlock}>
							{!!icon && <CdnIcon className={css.icon} icon={icon} />}

							<div className={css.content}>
								{!!label && <span className={css.label}>{label}</span>}
								{!!description && <span className={css.description}>{description}</span>}
							</div>
						</div>

						{!!onAction && (
							<CloseButton
								classes={{ root: css.closeButton }}
								variant="closePopup"
								onClick={onAction}
								disabled={disabled}
							/>
						)}
					</div>
				))}
		</div>
	);
};

export default ExchangeRefundMobileBreadcrumbs;
